var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, createContext, useState, } from "react";
export function createCtx(defaultValue) {
    var defaultUpdate = function () { return defaultValue; };
    var ctx = createContext({
        state: defaultValue,
        update: defaultUpdate,
    });
    function Provider(props) {
        var _a = useState(defaultValue), state = _a[0], update = _a[1];
        return _jsx(ctx.Provider, __assign({ value: { state: state, update: update } }, props));
    }
    return [ctx, Provider]; // alternatively, [typeof ctx, typeof Provider]
}
var _a = createCtx("someText"), ctx = _a[0], TextProvider = _a[1];
export var TextContext = ctx;
export function App() {
    return (_jsx(TextProvider, { children: _jsx(Component, {}) }));
}
export var AppContext = createContext({
    agents: [],
    setAgents: function (prefs) { },
    sessions: [],
    setSessions: function (prefs) { },
    chatPrefs: {},
    chatBubbleClicked: function () { },
    setChatPrefs: function (prefs) { },
    activeTab: "",
    changeActiveTab: function (tab) { },
    promtWidth: "",
    setPromtWidth: function (tab) { },
});
